<template>
  <v-container>

    <Titulo></Titulo>

    <NavBar v-if="loadMounted == true" :step="3" :typePlan="userData.typePlan"></NavBar>

    <br v-if="screen < 800">


    <v-stepper v-model="e1" elevation="0" style="margin-top: -80px;">
      <v-stepper-header>
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 1" step="1"> Inicio
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 2" step="2"> Planes
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 4" step="4"> DPS
          </v-stepper-step>
        </div>
        <v-divider></v-divider>
        <div class="circle-step2">
          <v-stepper-step style="flex-direction: column;" :color="stepperColor" :complete="e1 > 12"
            step="5">Datos</v-stepper-step>
        </div>
      </v-stepper-header>

      <v-stepper-items>

        <v-stepper-content step="6">
          <v-form ref="form2" v-model="valid">
            <v-container style="justify-content: center; display: flex; flex-direction: column; align-items: center;">
              <div class="form-container">
                <div :class="vista">

                  <br v-if="screen > 800">
                  <br v-if="screen > 800">
                  <br v-if="screen > 800">

                  <h3 v-if="userData.typePlan == 'Individual'" :class="labelTitulo">
                    {{ capitalizeName(userData.name) }}  ayúdanos a conocer tu estado de salud. 
                    
                  </h3>

                  <h3 v-else class="text-center labelSuperior">
                    Antes de continuar, debemos conocer el estado de tu salud y el de tu familia. Recuerda que responder
                    con información errónea podria afectar tu cobertura
                  </h3>
                  <br>
                  <p style="font-size: 15px; opacity: 0.90;">  Te recomendamos responder con información verídica para no afectar tu cobertura.</p>
                  <br>
                  <br>

                  <h3 :class="labelTitulo">
                    Declaración Personal de Salud
                  </h3>

                  <br>
                  <br>
        
                  <label :class="labelTexto">
                    <b>¿Te encuentras actualmente en estudio de un posible cáncer y/o tienes un diagnóstico oncológico o has recibido uno o más tratamientos oncológicos en los últimos 5 años?</b>
                  </label>
<!-- 
                  <br><br> -->

                  <div>
                    <v-radio-group v-model="userData.questionOne" :rules="questionRules" required row>
                      <div :class="vRadioSelect">
                        <v-radio label="Sí" value="Si">
                        </v-radio>
                        <v-radio label="No" value="No">
                        </v-radio>
                      </div>
                    </v-radio-group>
                  </div>

                  <br><br>

                </div>

              </div>

              <p></p>
              <p></p>
              

              <div class="form-container" style="margin-top: -3%;">
                <div :class="vista">


                  <label :class="labelBeneficioss">
                    <b>¿Te encuentras actualmente en estudio o conocimiento y/o has sido diagnosticado y/o sometido a tratamiento médico por alguna de las siguientes causas?</b>

                    <br>
                    <br>

                    • Virus Hepatitis B o Hepatitis C <br>
                    • Virus VIH <br>

                  </label>

                  <div>
                    <v-radio-group v-model="userData.questionTwo" required :rules="questionRules" row>
                      <div :class="vRadioSelect">
                        <v-radio label="Sí" value="Si">
                        </v-radio>
                        <v-radio label="No" value="No">
                        </v-radio>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
                </div>
                <br v-if="screen > 800">
              <div :class="textLegal">
                <p :class="textLegalDetalle"><b style="color: #2A3881;">Aviso:</b> De acuerdo al art. 8 bis de la Ley Nacional del Cáncer N°21.258, no debe declarar enfermedades oncológicas si han transcurridos 5 años o más desde la finalización del tratamiento radical de cáncer sin recaída posterior.</p>
              </div>

              <br>
              <br>
              <p></p>
              <p></p>

              <div class="button-container">
                <v-btn style="background-color: #2D387C; color: white; border-radius: 12px; width: 300px; "
                  @click="validate()">
                  Continuar
                </v-btn>

                <br>
                <br>

                <v-btn text @click="volverAgregar()">
                  Atrás
                </v-btn>

              </div>

            </v-container>
          </v-form>
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>

  </v-container>
</template>

<script>

import Titulo from "../components/Titulo.vue";
import NavBar from "@/components/NavBar.vue";

import CryptoJS from 'crypto-js';
import ShieldService from "../services/shield.service";

export default {
  name: "Step4",
  components: { Titulo, NavBar },
  data: () => ({
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
    secretKey: process.env.VUE_APP_CRYPT,
    loadMounted: false,
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      typeIsapre: null,
      region: null,
      commune: null,
      comuneCode: null,
      regionCode: null,
      address: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      stepId: null,
      old: null,
      dates: null,
      salud: null,
      questionOne: null,
      questionTwo: null,
      questionThree: null,
      typePlan: null,
      addressNumber: null,
      addressDepto: null,
      sonExist: false,
      arrayTypesBenef: [],
      oldAux: null,
      day: null,
      month: null,
      year: null,
    },
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'create',
    },
    labelTitulo: '',
    labelSuperior: '',
    labelTexto: '',
    labelBeneficioss: '',
    textLegal: '',
    vRadioSelect: '',
    textLegalDetalle: '',
    valid: false,
    stepperColor: '#4F74E3',
    screen: window.screen.width,
    nameSite: window.location.origin + '/documents/Articule.pdf',
    stepId: null,
    components: { Titulo },
    e1: 6,
    questionRules: [(v) => !!v || "Debe seleccionar una opción"],
  }),
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    const userDataAux = sessionStorage.getItem('userData');
    const servicesDataAux = sessionStorage.getItem('servicesData');
    if (userDataAux) {
      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);
    }

    if (servicesDataAux) {
        const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
        const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
        this.servicesData = JSON.parse(decryptedServicesData);
        // console.log("serivcesData: ", this.servicesData);
      }


    if (this.screen > 1001) {
      this.vista = 'vista2'
      this.labelTitulo ="labelTitulo"
      this.labelSuperior = 'labelSuperior'
      this.labelTexto = 'labelTexto'
      this.labelBeneficioss = 'labelBeneficioss'
      this.vRadioSelect = 'vRadioSelect'
      this.textLegal= 'textLegal'
      this.textLegalDetalle = 'textLegalDetalle'
    } else if (this.screen <= 767) {
      this.vista = 'vista'
      this.labelTitulo ="labelTituloMobile"
      this.labelSuperior = 'labelSuperiorMobile'
      this.labelTexto = 'labelTextoMobile'
      this.labelBeneficioss = 'labelBeneficiossMobile'
      this.vRadioSelect = 'vRadioSelectMobile'
      this.textLegal= 'textLegalMobile'
      this.textLegalDetalle = 'textLegalDetalleMobile'
    } if (this.screen >= 768 && this.screen <= 1000) {
      this.vista = 'vista2'
      this.labelTitulo ="labelTitulo"
      this.labelSuperior = 'labelSuperior'
      this.labelTexto = 'labelTexto'
      this.labelBeneficioss = 'labelBeneficioss'
      this.vRadioSelect = 'vRadioSelect'
      this.textLegal= 'textLegal'
      this.textLegalDetalle = 'textLegalDetalle'
    }

    this.loadMounted = true;
  },
  methods: {
    back() {
      this.e1--;
    },
    async validate() {
      if (this.$refs.form2.validate()) {
        if (this.userData.questionOne == 'Si' || this.userData.questionTwo == 'Si') {
          this.$router.push({ path: '/og/dps-fallida' })
        } else {

          const userDataLocal = JSON.stringify(this.userData);
          const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
          sessionStorage.setItem('userData', encryptedUserDataLocal);
          var shieldRes;
          if (this.userData.email && this.activeCampaingUse == 'TRUE') {
            const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);
            if (activeCampaingRes.data.data.meta.total == 1) {
              this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;
              await ShieldService.updateContactActiveCampain(this.userData, null, this.servicesData, 'dps');
            } else {
              shieldRes = await ShieldService.createContactActiveCampain(this.userData, this.servicesData);

              if (shieldRes.data.status == 'ok') {
                this.servicesData.contactID = shieldRes.data.data.contacts[0].id;
              }
            }

            const servicesDataLocal = JSON.stringify(this.servicesData);
            const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
            sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

          }

          this.$router.push({ path: '/og/datos-contratante' });
        }
      }
    },
    capitalizeName(name) {
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    volverAgregar() {
      this.$router.push({ path: '/og/planes' });
      // if (this.userData.typePlan == 'Individual') {
      //   this.$router.push({ path: '/og/planes' });
      // } else {
      //   this.$router.push({ path: '/og/beneficiarios' });
      // }
    }
  }
};

</script>

<style lang="scss">
.labelNumLlamar {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 50px;
  top: 175px;
  text-align: center;
}

.labelSuperior {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: justify;
  color: #232323;
  opacity: 0.75;
  height: 103px;
}

.labelSuperiorMobile {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 16px;
  text-align: justify;
  color: #232323;
  opacity: 0.75;
  height: 103px;
}

.labelTitulo {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: #2D387C;
  text-align: center;
}

.labelTituloMobile {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: #2D387C;
  text-align: center;
}

.labelQuestion1 {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  color: #4040CF;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  justify-content: left;
}

.labelTexto {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 30px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  text-align: justify;
}

.labelTextoMobile {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  // opacity: 0.75;
  height: 138px;
  text-align: justify;
  align-self: stretch;
}

.textLegalDetalle {
  // font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  justify-content: center;
  margin: auto;
  width: 70%;
  text-align: justify;
}

.textLegalDetalleMobile {
  // font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  text-align: justify;
  justify-content: justify;
  margin: auto;
  width: 80%;
}

.labelTexto-negrita {
  font-family: Helvetica;
  font-style: italic;
  font-weight: bold;
  font-size: 11px;
  line-height: 16px;
  color: #232323;
  height: 138px;
  text-align: justify;
  hyphens: auto;
}

.vRadioSelect {
  font-size: 22px;
  display: flex; 
}

.vRadioSelectMobile {
  font-size: 22px;
  display: flex; 
  margin: auto; 
  justify-content: center;
}

.labelBeneficioss {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 150px;
  text-align: justify;
}

.labelBeneficiossMobile {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #232323;
  // opacity: 0.75;
  height: 150px;
  text-align: justify;
}

.labelExcelente {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}

.labelSubExcelente {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
}

.labelNoExcelente {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
  margin-top: -5%;
}

.labelnoSubExcelente {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  height: 138px;
  top: 375px;
  text-align: center;
}

.vista {
  max-width: 1000px;
}

.vista2 {
  min-width: 670px;
}

.textLegal {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 14px;
  gap: 10px;
  width: 981px;
  height: 88px;
  background: #ECF0FC;
  border-radius: 4px;
}

.textLegalMobile {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 14px;
  gap: 10px;
  width: 100%;
  height: 100%;
  background: #ECF0FC;
  border-radius: 4px;
}

.step-data {
  max-width: 85%;
  align-items: center;
  // display: flex;
  margin-left: 2rem;
  justify-content: center;

  .v-select {
    max-width: 150px;
  }
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 800px;
}

.form-box {
  box-sizing: border-box;
  max-width: 800px;
  background: #F3F3F3;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  border-radius: 6px;
}

.v-input .v-label {
  font-size: 12px;
  color: #8E8E8E;
}

h1 {
  font-weight: 500;
  text-align: center;
  color: #464e71;
  margin-bottom: 2rem;
}

h2 {
  font-weight: 500;
  color: #464e71;
  margin-bottom: 1rem;
}

p {
  text-align: center;
}

.back-container {
  width: 100%;
  align-items: flex-start;

  .back-button {


    &:hover {
      opacity: 1;
    }
  }
}

.button-container {
  text-align: center;
}

.forecast-selector {
  text-transform: uppercase;
  font-weight: 600;
  color: #464e71;
}

.v-btn__content {
  padding: 0.75rem;
}

.v-messages__message {
  padding-bottom: 10%;
  text-align: center;
  margin: auto;
}

</style>